
export function normalizeCaseAndAccents(str) {
    if (str) {
        return str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }
    return str;
}